import { Button } from 'components/Button/Button'
import { translate } from 'i18n/i18n'
import { pushRoute } from 'utils/pushRoute'
import { DropdownSelectorProperty } from '../../../App/Map/PanelDetails/SectionTitleBars/DropdownSelectorProperty/DropdownSelectorProperty'
import type { TIcsDashboardControlsProps } from '../types'

export const IcsDashboardControls = ({
  onSavePDF,
  isLoading,
  showSavePDF = true,
}: TIcsDashboardControlsProps) => {
  return (
    <div
      className="no-print"
      css={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}
    >
      <div css={{ display: 'flex', gap: 10 }}>
        <Button variant="secondary" onClick={() => pushRoute('/')}>
          {translate.phrases.banyanApp('Return to Hub')}
        </Button>
        {showSavePDF && (
          <Button variant="secondary" onClick={onSavePDF} disabled={isLoading}>
            {translate.phrases.banyanApp('Save PDF')}
          </Button>
        )}
      </div>
      <DropdownSelectorProperty
        valuesTimeseriesToFilterOn={[]}
        propertyPermissionsToCheck={['VIEW_ICS_DASHBOARD']}
      />
    </div>
  )
}
